// extracted by mini-css-extract-plugin
module.exports = {"build-timestamp":"_2PJGWR","container":"kZF98q"};